import React, { useState, useEffect } from "react";

const Notification = ({ message, type = "info", duration = 5000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  // Add spinner animation keyframes to document head if not already added
  useEffect(() => {
    if (!document.getElementById("notification-spinner-styles")) {
      const style = document.createElement("style");
      style.id = "notification-spinner-styles";
      style.textContent = `
        @keyframes notification-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  if (!isVisible) return null;

  const getNotificationStyles = () => {
    const baseStyles = {
      position: "fixed",
      top: "20px",
      right: "20px",
      padding: "16px 20px",
      borderRadius: "8px",
      color: "white",
      fontWeight: "500",
      zIndex: 9999,
      maxWidth: "400px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      cursor: "pointer",
      transition: "all 0.3s ease",
    };

    switch (type) {
      case "error":
        return { ...baseStyles, backgroundColor: "#ef4444" };
      case "warning":
        return { ...baseStyles, backgroundColor: "#f59e0b" };
      case "success":
        return { ...baseStyles, backgroundColor: "#10b981" };
      default:
        return { ...baseStyles, backgroundColor: "#3b82f6" };
    }
  };

  const isLoading = duration === 0;

  return (
    <div 
      style={{
        ...getNotificationStyles(),
        cursor: isLoading ? "default" : "pointer",
      }} 
      onClick={isLoading ? undefined : handleClose}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {isLoading && (
            <svg
              style={{
                width: "20px",
                height: "20px",
                color: "white",
                animation: "notification-spin 1s linear infinite",
              }}
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                style={{
                  opacity: "0.25",
                }}
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                style={{
                  opacity: "0.75",
                }}
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <span>{message}</span>
        </div>
        {!isLoading && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleClose();
            }}
            style={{
              background: "none",
              border: "none",
              color: "white",
              fontSize: "18px",
              cursor: "pointer",
              marginLeft: "12px",
              padding: "0",
            }}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default Notification;
